import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

export type AppBarPageChromeContextValue = {
  setAppBarBreadcrumb: (node: React.ReactNode | null) => void;
  appBarBreadcrumb: React.ReactNode | null;
};

export const AppBarPageChromeContext = createContext<AppBarPageChromeContextValue | null>(null);

export function AppBarPageChromeProvider({ children }: { children: React.ReactNode }) {
  const [appBarBreadcrumb, setAppBarBreadcrumbState] = useState<React.ReactNode | null>(null);
  const setAppBarBreadcrumb = useCallback((node: React.ReactNode | null) => {
    setAppBarBreadcrumbState(node);
  }, []);

  const value = useMemo(
    () => ({ setAppBarBreadcrumb, appBarBreadcrumb }),
    [setAppBarBreadcrumb, appBarBreadcrumb],
  );

  return (
    <AppBarPageChromeContext.Provider value={value}>
      {children}
    </AppBarPageChromeContext.Provider>
  );
}

/** Returns null when used outside {@link AppBarPageChromeProvider} (e.g. Storybook). */
export function useOptionalAppBarPageChrome(): AppBarPageChromeContextValue | null {
  return useContext(AppBarPageChromeContext);
}
